import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FixedBenefit } from '../../../../core/models/fixed-benefit';
import { CoreTranslationService } from '../../../../../@core/services/translation.service';
import { BenefitsService } from '../../../../core/service/benefits.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { GetFixedBenefitResponse } from '../../../../core/responses/GetFixedBenefitResponse';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BenefitSummaryService } from '../../../../core/service/benefit-summary.service';
import { ShowBenefitComponent } from '../../../shared/show-benefit/show-benefit.component';
import { GetFixedBenefitDocumentsResponse } from '../../../../core/responses/GetFixedBenefitDocumentsResponse';
import { FixedBenefitDocument } from '../../../../core/models/fixed-benefit-document';
import { ShowDiscountComponent } from '../../../shared/show-discount/show-discount.component';
import { FixedBenefitType, quillEditorSettings } from 'app/core/helpers/constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UploadExpenseReportDocument } from '@core/validators/image-validator';
import { AuthenticationService } from 'app/core/service';
import { FileValidationService } from 'app/core/service/fileValidation.service';
import { ToastrService } from 'ngx-toastr';
import { SubdomainInfo } from 'app/core/models/subdomain-info';
import { BudgetAvailabilityType } from 'app/core/helpers/enums';
import { CompanyBenefitPolicyRequiredCheckboxDTO } from 'app/core/models/company-benefit-policy';
import { RequiredConsentsComponent } from 'app/main/shared/required-consents/required-consents.component';
import {ErrorMessage} from "../../../shared/error-messages/error-messages.component";

enum PROMOTION_OFFERS {
  DISCOUNT = '1',
  GENERAL = '2',
}

@Component({
  selector: 'app-fixed-benefits-info',
  templateUrl: './fixed-benefits-info.component.html',
  styleUrls: ['./fixed-benefits-info.component.scss'],
  providers: [
    TranslatePipe
  ]
})
export class FixedBenefitsInfoComponent implements OnInit, OnDestroy {

  public src: 'https://grad.msu.edu/sites/default/files/content/phd-career-services/images/examples-examples.jpg';
  private ngUnsubscribe = new Subject<void>();
  public fixedBenefit: FixedBenefit = null;
  public benefitId: string;
  public documents: Array<FixedBenefitDocument>;
  private discountsBuffer: Array<any>;
  private ExpenseReportForm: FormGroup | null = null;
  public selectedFiles: any[];
  private isExpenseReportBenefit = false;
  private userCompanyInfo: SubdomainInfo | null = null;
  modulesEditor: any = quillEditorSettings;
  addExpenseReportFormSubmitted  = false;
  expenseReportSent  = false;
  public policyCheckboxes: CompanyBenefitPolicyRequiredCheckboxDTO[] = [];
  errorMessages: ErrorMessage[] = [];
  @ViewChild(RequiredConsentsComponent) protected requiredConsentsRef: RequiredConsentsComponent;

  private readonly consentErrorMessage: ErrorMessage = { priority: 10 };

  constructor(
    private modalService: NgbModal,
    private _coreTranslationService: CoreTranslationService,
    private benefitsService: BenefitsService,
    private documentService: BenefitSummaryService,
    private authenticationService: AuthenticationService,
    private fileValidationService: FileValidationService,
    private _toastrService: ToastrService,
    private translate: TranslatePipe,
    private _route: ActivatedRoute,) {
    // this._coreTranslationService.translate(english, romanian);
    this.benefitId = this._route.snapshot.params.benefitId || '';
    this.selectedFiles = [];

  }

  quillBtnTitles = [
    { class: "ql-bold", title: "Bold" },
    { class: "ql-italic", title: "Italic" },
    { class: "ql-underline", title: "Underline" },
    { class: "ql-strike", title: "Strikethrough" },
    { class: "ql-blockquote", title: "Blockquote" },
    { class: "ql-list", value: "ordered", title: "Numbered List" },
    { class: "ql-list", value: "bullet", title: "Bullet List" },
    { class: "ql-indent", value: "-1", title: "Decrease Indent" },
    { class: "ql-indent", value: "+1", title: "Increase Indent" }
  ];

  private applyButtonTitles(): void {
    this.quillBtnTitles.forEach(btnMapping => {
      let selector = `.${btnMapping.class}`;

      if (btnMapping.value !== undefined) {
        // Handle buttons with same class but different values
        const buttons = document.querySelectorAll(selector);

        buttons.forEach(button => {
          if (button.getAttribute('value') === btnMapping.value || button.getAttribute('data-value') === btnMapping.value) {
            button.setAttribute('title', btnMapping.title);
          }
        });
      } else {
        // Handle buttons with unique classes
        const button = document.querySelector(selector);
        if (button) {
          button.setAttribute('title', btnMapping.title);
        } else {
          console.warn(`Button with class ${btnMapping.class} not found`);
        }
      }
    });
  }

  onEditorCreated(editor) {
    this.applyButtonTitles();
  }

  ngOnInit(): void {
    this.authenticationService.updateCurrentUserInfo();
    // Cache company info so we can compute the order-period range in error messages
    // (PLACE_ORDER.BUDGET_NOT_AVAILABLE — when decont Subtract is submitted outside the window).
    this.authenticationService.currentUserCompanyInfo
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(companyInfo => {
        if (companyInfo) {
          this.userCompanyInfo = companyInfo;
        }
      });
    this._route.params.subscribe(params => {
      this.benefitId = params['benefitId'] || '';
      if (this.benefitId) {
        this.ExpenseReportForm = new FormGroup({
          fullName: new FormControl(`${this.authenticationService.currentUserValue.firstName} ${this.authenticationService.currentUserValue.lastName}`, [Validators.required]),
          email: new FormControl(this.authenticationService.currentUserValue.email, [Validators.required]),
          ExpenseReportAmount: new FormControl('', [Validators.required, Validators.pattern('^[0-9.]{1,30}$')]),
          ExpenseReportDescription: new FormControl('', [Validators.required]),
          ExpenseReportDocuments: new FormControl('', [UploadExpenseReportDocument, Validators.required]),
        });
        this.ExpenseReportForm.get('ExpenseReportAmount').valueChanges
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(() => {
            const amountControl = this.ExpenseReportForm.get('ExpenseReportAmount');
            if (amountControl.errors?.limitExceeded) {
              amountControl.updateValueAndValidity({ emitEvent: false });
            }
          });
        this.getFixedBenefitDetails();
        this.getDocuments();
      }
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get f() {
    return this.ExpenseReportForm.controls;
  }


  /**
   * Get fixed benefit details
   */
  public getFixedBenefitDetails() {
    this.benefitsService.getUserFixedBenefitDetails(this.benefitId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          this.onGetFixedBenefitDetailsSuccess(data);
        },
        error => {
          this.onFixedBenefitDetailsFail(error);
        });
  }

  public onGetFixedBenefitDetailsSuccess(data: GetFixedBenefitResponse) {
    this.fixedBenefit = data.responseObject;
    this.isExpenseReportBenefit = this.fixedBenefit.fixedBenefitType === FixedBenefitType.Reimbursement;
    this.policyCheckboxes = data.responseObject.requiredCheckboxes ?? [];
    if (this.policyCheckboxes.some((c) => c.isRequired)) {
      setTimeout(() => this.onRequiredConsentChange());
    }
    if (this.fixedBenefit.name.includes('Promotii')) {
      this.getFixedBenefitDiscounts();
    }

  }

  public onFixedBenefitDetailsFail(error: HttpErrorResponse) {
  }

  public getFixedBenefitDiscounts() {
    this.benefitsService.getUserFixedBenefitDiscounts()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          this.onGetFixedBenefitDiscountsSuccess(data);
        },
        error => {
          this.onGetFixedBenefitDiscountsFail(error);
        });
  }

  public onGetFixedBenefitDiscountsSuccess(data: any) {
    let discounts = Array.isArray(data) && data.length > 0 ? data : [];
    // filter out discount that do not have an affiliate url
    discounts = discounts.filter(d=> d.affiliate_url !== null);
    // filter out offers not offering a discount
    discounts.forEach ( (store) => {
      store.offers = store.offers.filter( (offer) => offer.offer_type === PROMOTION_OFFERS.DISCOUNT);
    });
    // filter out stores not including any offer (due to the previous filter)
    discounts = discounts.filter((store) => store.offers.length > 0);
    this.fixedBenefit.discounts = discounts;
    this.discountsBuffer = discounts;
  }

  public onGetFixedBenefitDiscountsFail(error: HttpErrorResponse) {
    this.fixedBenefit.discounts = [];
    this.discountsBuffer = [];
  }

  /**
   * Get fixed benefit documents
   */
  public getDocuments() {
    this.documentService.getFixedBenefitDocuments(Number.parseInt(this.benefitId, 10))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          this.onGetDocumentsSuccess(data);
        },
        error => {
          this.onGetDocumentsFail(error);
        });
  }

  public onGetDocumentsSuccess(data: GetFixedBenefitDocumentsResponse) {
    this.documents = data.responseObject;
  }

  public onGetDocumentsFail(error: HttpErrorResponse) {
  }

  /**
   * Helpers
   */
  public getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  public selectFiles(event): void {
    const newFiles = Array.from(event.target.files);

    const allFiles = [...this.selectedFiles, ...newFiles];
    const validationResult = this.fileValidationService.validateTotalFileSize(allFiles);

    if (!validationResult.valid) {
      this.ExpenseReportForm.get('ExpenseReportDocuments').setErrors({
        fileSizeExceeded: {
          message: validationResult.message,
          params: validationResult.params
        }
      });
      return;
    }

    this.selectedFiles = allFiles;

    this.ExpenseReportForm.patchValue({
      ExpenseReportDocuments: ''
    });

    if (this.selectedFiles.length > 0) {
      const existingErrors = this.ExpenseReportForm.get('ExpenseReportDocuments').errors;
      if (existingErrors) {
        delete existingErrors.required;

        if (Object.keys(existingErrors).length === 0) {
          this.ExpenseReportForm.get('ExpenseReportDocuments').setErrors(null);
        } else {
          this.ExpenseReportForm.get('ExpenseReportDocuments').setErrors(existingErrors);
        }
      }
    }
  }

  public updateExpenseReportDocumentsErrors() {
    const existingErrors = this.ExpenseReportForm.get('ExpenseReportDocuments').errors;
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    const selectedFiles = this.selectedFiles;

    let newErrors = { ...existingErrors };

    // required files
    if (selectedFiles.length < 1) {
      newErrors = { ...newErrors, required: true };
    } else {
      delete newErrors.required;
    }

    // files type
    let typesOk = true;
    for (const file of selectedFiles) {
      if (!allowedTypes.includes(file.type)) {
        typesOk = false;
        break;
      }
    }

    if (!typesOk) {
      newErrors = { ...newErrors, invalidFileType: true };
    } else {
      delete newErrors.invalidFileType;
    }

    // number of files
    if (selectedFiles.length > 5) {
      newErrors = { ...newErrors, tooManyFiles: true };
    } else {
      delete newErrors.tooManyFiles;
    }

    // total size > 10mb
    let totalSize = 0;
    for (const file of selectedFiles) {
      totalSize += file.size;
    }
    if (totalSize > 10 * 1024 * 1024) { // 10 MB in bytes
      newErrors = { ...newErrors, fileSizeExceeded: true };
    } else {
      delete newErrors.fileSizeExceeded;
    }

    if (Object.keys(newErrors).length > 0) {
      this.ExpenseReportForm.get('ExpenseReportDocuments').setErrors(newErrors);
    } else {
      this.ExpenseReportForm.get('ExpenseReportDocuments').setErrors(null);
    }
  }

  public deleteFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

  public formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' '  + sizes[i];
  }

  public showDocument(document: FixedBenefitDocument) {
    const modalRef = this.modalService.open(ShowBenefitComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.document = document;
    modalRef.componentInstance.type = 'fixed';
  }

  public showDiscount(discount: any) {
    const modalRef = this.modalService.open(ShowDiscountComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.discount = discount;
  }

  public searchDiscounts(e: Event) {
    this.fixedBenefit.discounts = this.discountsBuffer?.filter(discount => discount?.store_name?.toLowerCase().includes((e.currentTarget as HTMLInputElement).value.toLowerCase()));
  }

  public async convertFiles(): Promise<any[]> {
    const files = [];
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles[i];
      const base64Value = await this.getBase64(file);
      files.push({
        name: file.name.replace(/\s/g, '_'),
        base64Value,
      });
    }
    return files;
  }

  public onRequiredConsentChange(): void {
    const hasRequired = this.policyCheckboxes.some((c) => c.isRequired);
    const isComplete = this.requiredConsentsRef?.isComplete() ?? true;
    if (hasRequired && !isComplete) {
      if (!this.errorMessages.includes(this.consentErrorMessage)) {
        this.consentErrorMessage.className = "not-eligible-warning font-small-3 mb-1";
        this.consentErrorMessage.text = 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.REQUIRED_CONSENTS_NOTICE';
        this.errorMessages = [this.consentErrorMessage, ...this.errorMessages];
      }
    } else {
      this.errorMessages = this.errorMessages.filter((e) => e !== this.consentErrorMessage);
    }
  }

  public async addExpenseReport() {
    this.updateExpenseReportDocumentsErrors();
    this.addExpenseReportFormSubmitted = true;
    if (this.ExpenseReportForm.invalid || !(this.requiredConsentsRef?.isComplete() ?? true)) {
      return;
    }

    const params: any = {
      userId: this.authenticationService.currentUserValue.userId,
      companyId: this.authenticationService.currentUserValue.companyId,
      expenseValue: this.ExpenseReportForm.get('ExpenseReportAmount')?.value,
      description: this.ExpenseReportForm.get('ExpenseReportDescription').value,
      fixedBenefitId: this.benefitId,
      files: await this.convertFiles(),
      submittedConsents: this.requiredConsentsRef?.getSubmittedConsents() ?? [],
    };

    this.benefitsService.addFixedBenefitExpenseReport(params).subscribe(
      (data) => {
        this.onAddFixedBenefitExpenseReportSuccess(data);
      },
      (error) => {
        this.onAddFixedBenefitExpenseReportFail(error);
      }
    );
  }

  public onAddFixedBenefitExpenseReportSuccess(data: any) {
    this.expenseReportSent = true;
  }

  private readonly expenseReportLimitErrorCodes = [
    'ADD_EXPENSE_REPORT.LIMIT_PER_REQUEST_EXCEEDED',
    'ADD_EXPENSE_REPORT.MONTHLY_LIMIT_EXCEEDED',
  ];

  public onAddFixedBenefitExpenseReportFail(error: any) {
    const errorCode = error?.error?.errors?.[0]?.code || error?.messages?.[0] || 'EXPENSE_REPORT.GENERIC_ERROR';

    if (this.expenseReportLimitErrorCodes.includes(errorCode)) {
      const limitMessage = this.translate.transform(`EXPENSE_REPORT.ERRORS.${errorCode}`);
      this.ExpenseReportForm.get('ExpenseReportAmount').setErrors({ limitExceeded: { message: limitMessage } });
      return;
    }

    // Special-case PLACE_ORDER.BUDGET_NOT_AVAILABLE: reuse the same translation as the regular
    // order placement so the user sees the familiar "A trecut perioada de comandă a lunii: X - Y"
    // message instead of a generic fallback.
    let message: string;
    if (errorCode === 'PLACE_ORDER.BUDGET_NOT_AVAILABLE') {
      const period = this.computeBudgetAvailabilityPeriod();
      message = this.translate.transform('FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE', {period});
    } else if (errorCode.includes("UPLOAD_FILE")) {
      message = this.translate.transform(errorCode);
    } else {
      const translationKey = `EXPENSE_REPORT.ERRORS.${errorCode}`;
      message = this.translate.transform(translationKey);
      if (message === translationKey) {
        message = this.translate.transform('EXPENSE_REPORT.ERRORS.GENERIC');
      }
    }

    this._toastrService.error(
      message,
      this.translate.transform('ERROR'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 5000 }
    );
  }

  private computeBudgetAvailabilityPeriod(): string {
    if (!this.userCompanyInfo) {
      return '';
    }
    const startDay = this.userCompanyInfo.actualBalanceLoadDay || this.userCompanyInfo.balanceLoadDay;
    const endDay = this.userCompanyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed
      ? this.userCompanyInfo.budgetAvailabilityInDays
      : startDay + this.userCompanyInfo.budgetAvailabilityInDays - 1;
    return `${startDay} - ${endDay}`;
  }
}
